import { InstanceAddStepTwoForm } from "./InstanceAddStepTwoForm";
import { InstanceAddStepTwoFormFields } from "./InstanceAddStepTwoFormFields";
import React from "react";
import { ICRMInstance } from "../../../../models/Accounts";
import { TFunction } from "next-i18next";

export function InstanceAddStepTwoFormWrapper({
  t,
  editMode,
  adminsError,
  renderFullPage,
  FormStepperArray,
  steps,
  internalInstance,
  formArray,
  detailsValidationSchema,
  instanceAdmins,
  onOutsideClick,
  setAdminsError,
  setFormArray,
  setSteps,
  handleDomainCheck,
  setAdmin,
}: {
  renderFullPage: boolean;
  editMode: boolean;
  adminsError: string;
  FormStepperArray: { label: string }[];
  steps: number;
  internalInstance: Partial<ICRMInstance>;
  formArray: Record<string, any>;
  detailsValidationSchema: any;
  instanceAdmins: string[];
  t: TFunction;
  onOutsideClick: (value: boolean) => void;
  setAdminsError: (value: ((prevState: string) => string) | string) => void;
  setFormArray: (
    value:
      | ((prevState: Record<string, any>) => Record<string, any>)
      | Record<string, any>
  ) => void;
  setSteps: (value: ((prevState: number) => number) | number) => void;
  handleDomainCheck: (values: string) => Promise<void>;
  setAdmin: (value: ((prevState: string[]) => string[]) | string[]) => void;
}) {
  return (
    <InstanceAddStepTwoForm
      renderFullPage={renderFullPage}
      steps={FormStepperArray}
      activeStep={steps}
      internalInstance={internalInstance}
      formArray={formArray}
      validationSchema={detailsValidationSchema}
      onNextClick={(values) => {
        if (!instanceAdmins || instanceAdmins.length === 0) {
          setAdminsError("Please enter at least one valid email.");
          return;
        }
        setFormArray({
          ...formArray,
          ...values,
          ...{ instanceAdmins: instanceAdmins },
        });
        setSteps(steps + 1);
      }}
      onOutsideClick={onOutsideClick}
      element={({ handleSubmit, setFieldTouched, values, handleChange }) => (
        <InstanceAddStepTwoFormFields
          onSubmit={(e) => e.preventDefault()}
          label={t("sub-domain-label")}
          onBlur={async () => {
            setFieldTouched("subdomain");
            await handleDomainCheck(values["subdomain"]);
          }}
          disabled={editMode}
          placeholder={t("sub-domain-placeholder")}
          values={values}
          adminLabel={t("admin-label")}
          items={instanceAdmins}
          handleAdd={(values) => setAdmin(values)}
          adminsError={adminsError}
          descriptionLabel={t("description-label")}
          descriptionPlaceholder={t("description-placeholder")}
          sampleLabel={t("isSample-label")}
          backButton={() => {
            setSteps(steps - 1);
            setFormArray({
              ...formArray,
              ...values,
              ...{ instanceAdmins: instanceAdmins },
            });
          }}
          nextButton={handleSubmit}
        />
      )}
    />
  );
}
